<template>
  <div id="pageRoot">
    <div id="radio0">
      <label class="toggleButtonContainer pageElement" id="toggle01"
        >MASA
        <input type="radio" name="masa" 
        ref="1-1" 
        v-on:change="saveOption('radios', 1, 1)" 
        :onload="loadOption('radios', 1, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle02"
        >MAGIA
        <input type="radio" name="masa" 
        ref="1-2" 
        v-on:change="saveOption('radios', 1, 2)" 
        :onload="loadOption('radios', 1, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle03"
        >MOSCA
        <input type="radio" name="masa" 
        ref="1-3" 
        v-on:change="saveOption('radios', 1, 3)" 
        :onload="loadOption('radios', 1, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio1">
      <label class="toggleButtonContainer pageElement" id="toggle11"
        >CANGURO
        <input type="radio" name="canguro" 
        ref="2-1" 
        v-on:change="saveOption('radios', 2, 1)" 
        :onload="loadOption('radios', 2, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle12"
        >CAMINO
        <input type="radio" name="canguro" 
        ref="2-2" 
        v-on:change="saveOption('radios', 2, 2)" 
        :onload="loadOption('radios', 2, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle13"
        >CANGREJO
        <input type="radio" name="canguro" 
        ref="2-3" 
        v-on:change="saveOption('radios', 2, 3)" 
        :onload="loadOption('radios', 2, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio2">
      <label class="toggleButtonContainer pageElement" id="toggle21"
        >RATA
        <input type="radio" name="rata" 
        ref="3-1" 
        v-on:change="saveOption('radios', 3, 1)" 
        :onload="loadOption('radios', 3, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle22"
        >RAMA
        <input type="radio" name="rata" 
        ref="3-2" 
        v-on:change="saveOption('radios', 3, 2)" 
        :onload="loadOption('radios', 3, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle23"
        >RANA
        <input type="radio" name="rata" 
        ref="3-3" 
        v-on:change="saveOption('radios', 3, 3)" 
        :onload="loadOption('radios', 3, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio3">
      <label class="toggleButtonContainer pageElement" id="toggle31"
        >CARA
        <input type="radio" name="cara" 
        ref="4-1" 
        v-on:change="saveOption('radios', 4, 1)" 
        :onload="loadOption('radios', 4, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle32"
        >CARTEL
        <input type="radio" name="cara" 
        ref="4-2" 
        v-on:change="saveOption('radios', 4, 2)" 
        :onload="loadOption('radios', 4, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle33"
        >CARACOL
        <input type="radio" name="cara" 
        ref="4-3" 
        v-on:change="saveOption('radios', 4, 3)" 
        :onload="loadOption('radios', 4, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <img id="fly" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo7Fly.svg">
    <img id="crab" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo8Crab.svg">
    <img id="frog" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo10FrogFlip.svg">
    <img id="snail" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo8SnailFlip.svg">
  </div>
</template>
<style scoped>
#toggle01 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 213px;
  top: 193px;
}
#toggle02 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 213px;
  top: 248px;
}
#toggle03 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 213px;
  top: 302px;
}

#toggle11 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 186px;
}
#toggle12 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 240px;
}
#toggle13 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 293px;
}

#toggle21 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 216px;
  top: 497px;
}
#toggle22 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 216px;
  top: 551px;
}
#toggle23 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 216px;
  top: 604px;
}

#toggle31 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 497px;
}
#toggle32 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 551px;
}
#toggle33 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 717px;
  top: 604px;
}

#fly{
    position: absolute;
    left: 54px;
    top: 177px;
}
#crab{
    position: absolute;
    left: 463px;
    top: 200px;
}
#frog{
    position: absolute;
    left: 50px;
    top: 490px;
}
#snail{
    position: absolute;
    left: 510px;
    top: 500px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>